// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*flex-direction: row-reverse;*/
  padding: 5% 6%;
}
.detail-header .menu-logo {
  max-width: 21%;
}
.detail-header .back {
  text-decoration: none;
  width: 8%;
}

.list {
  margin: 0 6%;
  padding-bottom: 6%;
}
.list .title {
  background-color: #caa36c;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  display: flex;
  align-items: center;
  padding: 0px 25px;
}
.list .title.sub {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.list .title h2 {
  font: 2.2em/1 vigaregular;
  color: #fff;
  padding: 10px 0;
}
.list .title img.sep-icon {
  max-height: 70px;
  margin-left: -25px;
  height: 15vw;
}
.list .title .edit {
  top: 20%;
  right: 4%;
  position: absolute;
}
.list .title .edit img {
  width: 16px;
  height: 16px;
}
.list .content {
  background-color: #fff;
}
.list .content ul {
  min-height: 150px;
  padding: 0 4%;
}
.list .content ul li {
  border-bottom: 2px solid #f2f2f2;
  border-radius: 4px;
  padding: 5.5% 0;
}
.list .content ul li:last-child {
  border-bottom: none;
}
.list .content ul li .item {
  display: flex;
}
.list .content ul li .item .thumb figure {
  text-align: center;
  overflow: hidden;
  height: 105px;
  width: 105px;
}
.list .content ul li .item .thumb figure img {
  transform: translateX(-50%);
  position: absolute;
  height: 100%;
  width: auto;
  left: 50%;
}
.list .content ul li .item .details {
  display: block;
  margin-left: 4%;
  width: 100%;
}
.list .content ul li .item .plate {
  width: 90%;
  min-height: 25px;
  margin-bottom: 4%;
}
.list .content ul li .item .plate.edit-btn {
  width: 85%;
}
.list .content ul li .item .plate h3 {
  font: 2em/1.2em vigaregular;
  color: #5C5C5C;
  margin-bottom: 10px;
}
.list .content ul li .item .plate p {
  font: 1.2em/1.35 vigaregular;
  color: #5C5C5C;
}
.list .content ul li .item .plate p i {
  font-style: italic;
}
.list .content ul li .item .price {
  font: 1.9em/1 vigaregular;
  color: #caa36a;
}
.list .content ul li .item .price h4 {
  margin-top: 15px;
}
.list .content ul li .item .multi {
  display: flex;
  flex-flow: row wrap;
  min-height: auto;
  padding: 0;
  margin: 0;
  list-style: none;
}
.list .content ul li .item .multi .product-item {
  line-height: 1.3em;
  flex: 0 0 33.3333%;
  position: relative;
  text-align: left;
  border: none;
  padding: 4% 0;
}
.list .content ul li .item .multi .product-item .product-label {
  font: 1em/1 vigaregular;
  color: #595959;
}
.list .content ul li .item .multi .product-item .product-price {
  font: 1.4em/1 vigaregular;
  color: #caa36c;
  margin-top: 5px;
}
.list .content ul li .item.no-thumb .details {
  display: block;
  margin: 0;
}
.list .content ul li .item.no-thumb .details.full {
  display: block;
  /*
  .multi {
      margin-left: 4%;
  }
  */
}
.list .content ul li .item.no-thumb .plate {
  width: 70%;
  min-height: 25px;
}
.list .content ul li .item.no-thumb .price {
  font: 1.9em/1 vigaregular;
  color: #caa36a;
  margin-right: 2%;
  width: 30%;
}
.list .content ul li .item.no-thumb .multi {
  left: 0;
}
.list .content ul li .item.no-thumb .multi .product-item {
  flex: 0 0 25%;
}
.list .content .no-products {
  color: #5C5C5C;
  font: 1.9em/1 vigaregular;
  width: 100%;
  padding: 35px 0px;
  text-align: center;
}
.list .content .buttons {
  padding: 5% 8%;
}
.list .content .buttons a {
  border: 2px solid #caa36c;
  text-decoration: none;
  text-align: center;
  border-radius: 5px;
  padding: 15px 0;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}
.list .content .buttons a img {
  vertical-align: middle;
  margin-bottom: 2%;
  margin-right: 3%;
  width: 8%;
}
.list .content .buttons a span {
  font: 1.9em/1 vigaregular;
  color: #caa36c;
}
.list .content .buttons a .icon-drinks {
  font-size: 4em;
  margin-right: 10px;
}
.list footer {
  display: flex;
}
.list footer:before {
  content: "";
  height: 20px;
  background-color: #fff;
  width: calc(100% - 20px);
}
.list footer:after {
  width: 0;
  height: 0;
  content: "";
  border-top: 20px solid #dbdbdb;
  border-right: 20px solid transparent;
}

.banner {
  padding: 6%;
}
.banner img {
  width: 100%;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/menu/MenuItems.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,cAAA;AACJ;AACI;EACI,cAAA;AACR;AAEI;EACI,qBAAA;EACA,SAAA;AAAR;;AAIA;EACI,YAAA;EACA,kBAAA;AADJ;AAGI;EACI,yBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AADR;AAGQ;EACI,8BAAA;EACA,+BAAA;AADZ;AAIQ;EACI,yBAAA;EACA,WAAA;EACA,eAAA;AAFZ;AAKQ;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;AAHZ;AAOQ;EACI,QAAA;EACA,SAAA;EACA,kBAAA;AALZ;AAOY;EACI,WAAA;EACA,YAAA;AALhB;AAWI;EACI,sBAAA;AATR;AAWQ;EACI,iBAAA;EACA,aAAA;AATZ;AAWY;EAEI,gCAAA;EACA,kBAAA;EACA,eAAA;AAVhB;AAYgB;EACI,mBAAA;AAVpB;AAagB;EACI,aAAA;AAXpB;AAcwB;EACI,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,YAAA;AAZ5B;AAc4B;EACI,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;AAZhC;AAiBoB;EACI,cAAA;EACA,eAAA;EACA,WAAA;AAfxB;AAkBoB;EACI,UAAA;EACA,gBAAA;EACA,iBAAA;AAhBxB;AAkBwB;EACI,UAAA;AAhB5B;AAmBwB;EACI,2BAAA;EACA,cAAA;EACA,mBAAA;AAjB5B;AAoBwB;EACI,4BAAA;EACA,cAAA;AAlB5B;AAmB4B;EACI,kBAAA;AAjBhC;AAsBoB;EACI,yBAAA;EACA,cAAA;AApBxB;AAsBwB;EACI,gBAAA;AApB5B;AAwBoB;EAEI,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;AAvBxB;AAyBwB;EACI,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AAvB5B;AAyB4B;EACI,uBAAA;EACA,cAAA;AAvBhC;AA0B4B;EACI,yBAAA;EACA,cAAA;EACA,eAAA;AAxBhC;AA8BwB;EACI,cAAA;EACA,SAAA;AA5B5B;AA8B4B;EACI,cAAA;EACA;;;;GAAA;AAxBhC;AA+BwB;EACI,UAAA;EACA,gBAAA;AA7B5B;AA+BwB;EACI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,UAAA;AA7B5B;AAgCwB;EACI,OAAA;AA9B5B;AAgC4B;EACI,aAAA;AA9BhC;AAsCQ;EACI,cAAA;EACA,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AApCZ;AAuCQ;EACI,cAAA;AArCZ;AAuCY;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;AArChB;AAuCgB;EACI,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;AArCpB;AAwCgB;EACI,yBAAA;EACA,cAAA;AAtCpB;AAyCgB;EACI,cAAA;EACA,kBAAA;AAvCpB;AA6CI;EACI,aAAA;AA3CR;AA6CQ;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,wBAAA;AA3CZ;AA8CQ;EACI,QAAA;EACA,SAAA;EACA,WAAA;EACA,8BAAA;EACA,oCAAA;AA5CZ;;AAiDA;EACI,WAAA;AA9CJ;AAgDI;EACI,WAAA;EACA,YAAA;AA9CR","sourcesContent":[".detail-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    /*flex-direction: row-reverse;*/\n    padding: 5% 6%;\n\n    .menu-logo {\n        max-width: 21%;\n    }\n\n    .back {\n        text-decoration: none;\n        width: 8%;\n    }\n}\n\n.list {\n    margin: 0 6%;\n    padding-bottom: 6%;\n\n    .title {\n        background-color: #caa36c;\n        border-top-left-radius: 5px;\n        border-top-right-radius: 5px;\n        display: flex;\n        align-items: center;\n        padding: 0px 25px;\n\n        &.sub{\n            border-bottom-left-radius: 5px;\n            border-bottom-right-radius: 5px;\n        }\n\n        h2 {\n            font: 2.2em/1 vigaregular;\n            color: #fff;\n            padding: 10px 0;\n        }\n\n        img.sep-icon {\n            max-height: 70px;\n            margin-left: -25px;\n            height: 15vw;\n        }\n        \n\n        .edit{\n            top: 20%;\n            right: 4%;\n            position: absolute;\n\n            img{\n                width: 16px;\n                height: 16px;\n            }\n        }\n\n    }\n\n    .content {\n        background-color: #fff;\n\n        ul {\n            min-height: 150px;\n            padding: 0 4%;\n\n            li {\n                // border-bottom: 1px solid #979797;\n                border-bottom: 2px solid #f2f2f2;\n                border-radius: 4px;\n                padding: 5.5% 0;\n\n                &:last-child {\n                    border-bottom: none;\n                }\n\n                .item {\n                    display: flex;\n\n                    .thumb {\n                        figure {\n                            text-align: center;\n                            overflow: hidden;\n                            height: 105px;\n                            width: 105px;\n\n                            img {\n                                transform: translateX(-50%);\n                                position: absolute;\n                                height: 100%;\n                                width: auto;\n                                left: 50%;\n                            }\n                        }\n                    }\n\n                    .details {\n                        display: block;\n                        margin-left: 4%;\n                        width: 100%;\n                    }\n\n                    .plate {\n                        width: 90%;\n                        min-height: 25px;\n                        margin-bottom: 4%;\n\n                        &.edit-btn{\n                            width: 85%;\n                        }\n\n                        h3 {\n                            font: 2em/1.2em vigaregular;\n                            color: #5C5C5C;\n                            margin-bottom: 10px;\n                        }\n\n                        p {\n                            font: 1.2em/1.35 vigaregular;\n                            color: #5C5C5C;\n                            i {\n                                font-style: italic;\n                            }\n                        }\n                    }\n\n                    .price {\n                        font: 1.9em/1 vigaregular;\n                        color: #caa36a;\n\n                        h4 {\n                            margin-top: 15px;\n                        }\n                    }\n\n                    .multi {\n                        // border-top: 1px solid #dfdfdf;\n                        display: flex;\n                        flex-flow: row wrap;\n                        min-height: auto;\n                        padding: 0;\n                        margin: 0;\n                        list-style: none;\n\n                        .product-item {\n                            line-height: 1.3em;\n                            flex: 0 0 33.3333%;\n                            position: relative;\n                            text-align: left;\n                            border: none;\n                            padding: 4% 0;\n\n                            .product-label {\n                                font: 1em/1 vigaregular;\n                                color: #595959;\n                            }\n\n                            .product-price {\n                                font: 1.4em/1 vigaregular;\n                                color: #caa36c;\n                                margin-top: 5px;\n                            }\n                        }\n                    }\n\n                    &.no-thumb {\n                        .details {\n                            display: block;\n                            margin: 0;\n\n                            &.full {\n                                display: block;\n                                /*\n                                .multi {\n                                    margin-left: 4%;\n                                }\n                                */\n                            }\n                        }\n                        .plate {\n                            width: 70%;\n                            min-height: 25px;\n                        }\n                        .price {\n                            font: 1.9em/1 vigaregular;\n                            color: #caa36a;\n                            margin-right: 2%;\n                            width: 30%;\n                        }\n\n                        .multi {\n                            left: 0;\n\n                            .product-item {\n                                flex: 0 0 25%;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        .no-products{\n            color: #5C5C5C;\n            font: 1.9em/1 vigaregular;\n            width: 100%;\n            padding: 35px 0px;\n            text-align: center;\n        }\n\n        .buttons {\n            padding: 5% 8%;\n\n            a {\n                border: 2px solid #caa36c;\n                text-decoration: none;\n                text-align: center;\n                border-radius: 5px;\n                padding: 15px 0;\n                display: flex;\n                cursor: pointer;\n                align-items: center;\n                justify-content: center;\n\n                img {\n                    vertical-align: middle;\n                    margin-bottom: 2%;\n                    margin-right: 3%;\n                    width: 8%;\n                }\n\n                span {\n                    font: 1.9em/1 vigaregular;\n                    color: #caa36c;\n                }\n\n                .icon-drinks{\n                    font-size: 4em;\n                    margin-right: 10px;\n                }\n            }\n        }\n    }\n\n    footer {\n        display: flex;\n\n        &:before {\n            content: \"\";\n            height: 20px;\n            background-color: #fff;\n            width: calc(100% - 20px);\n        }\n\n        &:after {\n            width: 0;\n            height: 0;\n            content: \"\";\n            border-top: 20px solid #dbdbdb;\n            border-right: 20px solid transparent;\n        }\n    }\n}\n\n.banner {\n    padding: 6%;\n\n    img {\n        width: 100%;\n        height: auto;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
